import { useEffect, useRef } from "react";

type OneTimeEffectOptions = {
  condition: boolean;
  effect: () => void | Promise<void>;
};

export function useOneTimeEffect({ condition, effect }: OneTimeEffectOptions) {
  const hasRun = useRef(false);

  useEffect(() => {
    if (condition && !hasRun.current) {
      hasRun.current = true;
      void effect(); // effect mag async zijn
    }
  }, [condition, effect]);
}
